import PropTypes from "prop-types";

import { useWebReviewScore } from "../../hooks/useWebReviewScore";
import { BaseRating } from "./BaseRating";

export const BaseSoftwareRating = ({ classNames }) => {
	const { score } = useWebReviewScore();
	if (score === 0) return null;

	return (
		<div className={classNames?.wrapper}>
			<div className={classNames?.stars}>
				<BaseRating
					className={classNames?.starSize}
					precision={0.1}
					filledColor={classNames?.starColor}
					score={score}
				/>
			</div>
			<p className={classNames?.score}>{score.toFixed(1)} out of 5</p>
		</div>
	);
};

BaseSoftwareRating.propTypes = {
	classNames: PropTypes.object,
};
